<script>
  import { onMount } from "svelte";
  import Toggle from "lib/components/Toggle.svelte";
  import { llmSettings, loadLlmSettings } from "@stores/llmSettingsStore.js";

  // Eigenes Cloud-Modell an: Kunde bringt Schluessel, Endpunkt und Modellnamen seines
  // Anbieters mit, sonst laufen die paxray-Modelle aus der Umgebung. Aus: lokales Modell
  // hinter einem kompatiblen Server. Gespeichert wird mit "Save settings" der Seite;
  // leere Felder bedeuten Plattform-Standard.
  //
  // Die Maske nennt bewusst KEINE Anbieter, Modellnamen oder Standard-Adressen
  // (Nutzervorgabe 17.09.2026): welche Modelle paxray einsetzt, ist nicht Kundensache.
  // Deshalb erscheinen env_base_url und effective_local_base_url hier nicht als Platzhalter.
  let error = "";

  onMount(async () => {
    try {
      await loadLlmSettings();
    } catch (e) {
      error = "LLM settings could not be loaded.";
    }
  });
</script>

<div class="llm-settings">
  <Toggle
    text="Use your own cloud model"
    active={$llmSettings.cloud}
    on:change={(event) => ($llmSettings.cloud = event.detail)}
  />

  {#if $llmSettings.cloud}
    <p class="hint">
      Connect a cloud model of your own provider. Leave the fields empty to keep
      {$llmSettings.has_api_key
        ? `your stored key (${$llmSettings.api_key_hint})`
        : "the paxray models enabled for your account"}.
    </p>
    <label>
      <span>API key of your provider</span>
      <input
        type="password"
        autocomplete="off"
        placeholder={$llmSettings.has_api_key ? $llmSettings.api_key_hint : "Leave empty to use the paxray models"}
        bind:value={$llmSettings.api_key}
      />
    </label>
    {#if $llmSettings.has_api_key}
      <label class="inline">
        <input type="checkbox" bind:checked={$llmSettings.clear_api_key} />
        <span>Remove the stored key and return to the paxray models</span>
      </label>
    {/if}
    <label>
      <span>Endpoint URL (empty = paxray default)</span>
      <input type="text" placeholder="Endpoint of your provider" bind:value={$llmSettings.base_url} />
    </label>
    <label>
      <span>Model name (empty = paxray default per feature)</span>
      <input type="text" placeholder="Model name at your provider" bind:value={$llmSettings.model} />
    </label>
  {:else}
    <p class="hint">
      Local model on your own server. Leave the fields empty to keep the paxray models enabled
      for your account.
    </p>
    <label>
      <span>Local server URL (empty = paxray default)</span>
      <input type="text" placeholder="Address of your local model server" bind:value={$llmSettings.local_base_url} />
    </label>
    <label>
      <span>Local model name (empty = paxray default)</span>
      <input type="text" placeholder="Model name on your local server" bind:value={$llmSettings.local_model} />
    </label>
  {/if}
  <label>
    <span>Company profile for Pax AI (who the company is and who its customers are)</span>
    <textarea
      rows="3"
      placeholder="e.g. Automotive supplier of mirror systems; customers are truck, bus and agricultural machinery OEMs."
      bind:value={$llmSettings.company_profile}
    ></textarea>
  </label>
  {#if error}<span class="err">{error}</span>{/if}
</div>

<style>
  /* Schliesst nahtlos an die Schalterliste der Karte an: der Cloud-LLM-Schalter
     sitzt im selben Raster wie "Show Account Settings", die Felder folgen darunter. */
  .llm-settings {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    margin-top: -1rem;
    padding: 0 1rem 1rem;
  }
  .llm-settings :global(.toggle_wrapper) {
    padding: 0;
    /* Die Karte laesst die letzte Zeile ihrer Liste ohne Strich - hier den
       Trennstrich nach oben und unten ziehen, damit die Reihe einheitlich bleibt. */
    border-top: 1px solid rgba(28, 28, 32, 0.12);
    border-bottom: 1px solid rgba(28, 28, 32, 0.12);
  }
  .hint {
    margin: 0;
    font-size: 0.8rem;
    color: rgba(28, 28, 32, 0.7);
  }
  label {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    font-size: 0.8rem;
  }
  label.inline {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }
  input[type="text"],
  input[type="password"],
  textarea {
    padding: 0.45rem 0.6rem;
    border: 1px solid rgba(28, 28, 32, 0.3);
    border-radius: 0.35rem;
    font: inherit;
    resize: vertical;
  }
  .err {
    color: #b42318;
    font-size: 0.8rem;
  }
</style>
